import { isDiscountItemPrice, isMemberRewardItemPrice } from '../../../../sales-data/utils/items/item-price-utils';
import { mapInProgressNormalItemToOrderNormalItemLine } from './map-in-progress-normal-item-to-order-normal-item-line';
export const mapInProgressParentSalesItemToOrderNormalItemLines = (inProgressItem) => {
    const { selectedInProgressItems } = inProgressItem;
    if (!selectedInProgressItems) {
        throw new Error(`Parent sales item ${inProgressItem.item.id} (${inProgressItem.item.shortName}) has no selected options`);
    }
    const selectedOptions = Object.values(selectedInProgressItems).reduce((acc, option) => {
        const selectedOptionsForOptionQuantity = new Array(option.quantity).fill(option.item);
        acc.push(...selectedOptionsForOptionQuantity);
        return acc;
    }, []);
    return selectedOptions.map(optionItem => {
        const itemPrice = optionItem.selectedPrice;
        return Object.assign(Object.assign({}, mapInProgressNormalItemToOrderNormalItemLine(optionItem)), { rewardId: isMemberRewardItemPrice(itemPrice) ? itemPrice.rewardId : undefined, discountId: isDiscountItemPrice(itemPrice) ? itemPrice.discountId : undefined, parentSalesItemId: inProgressItem.item.id });
    });
};
